import {BalanceIcon} from "@/utils/icons";
import {convertNumberCost} from "@/helpers/convertNumberCost";
import setSettingsFromServer from "@/helpers/setSettingsFromServer"
import s from './index.module.css';
import { useEffect, useState } from "react";
import { selectProfile } from "@store/profile.reducer";
import { useSelector } from "react-redux";
import Preloader from "@UI/Preloader";

const BalanceBlock = () => {
    const profile = useSelector(selectProfile)
    const parentSelectedChild = useSelector(state => state.parentSelectedChild)
    const parentSelectedChildId = useSelector(state => state.parentSelectedChildId)
    const [settings, setSettings] = useState(null);
    useEffect(() => {
        setSettingsFromServer(setSettings)
    }, []);

    const balance = profile.role === 'parent' ? parentSelectedChild.data.balance ?? 0 : profile.balance ?? 0;

    if(settings?.isFreeCourses !== '0' || (profile.role !== 'children' && profile.role !== 'parent')) return <></>;
    if(profile.role === 'parent' && !parentSelectedChildId) return <></>;
    
    return (
        <div className={s.balanceBlock}>
            <div className={s.balanceWrapper}>
                {
                    parentSelectedChild.status === 'loading' ? (
                        <div style={{margin: 'auto'}}>
                            <Preloader />
                        </div>
                    ) : (
                        <>
                            <div className={s.balanceIcon}>
                                <BalanceIcon/>
                            </div>
                            <div className={s.balance}>
                                <div className={s.balanceCount}>
                                    Баланс
                                    <div className={s.money}>{convertNumberCost(balance ?? 0)} ₽</div>
                                </div>
                                <div className={s.balanceFooter}>
                                    <span>0 €</span>
                                    <span>0 $</span>
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
        </div>
    )
}

export default BalanceBlock;